module.exports = __webpack_public_path__ + "img/tooltip.8e442057.svg";